export const EMAIL_CHANGED = 'email_changed'
export const PASSWORD_CHANGED = 'password_changed'
export const LOGIN_USER_SUCCESS = 'login_user_success'
export const LOGIN_USER_FAIL = 'login_user_fail'
export const LOGIN_USER = 'login_user'
export const LOGOUT_USER = 'logout_user'
export const UPDATE_USER_INFO = 'update_user_info'
export const UPDATE_ADDRESS_INFO = 'UPDATE_ADDRESS_INFO'
export const UPDATE_HEALTH_SYSTEM_INFO = 'UPDATE_HEALTHSYSTEM_INFO'
export const UPDATE_HEALTH_ACTIVITY_INFO = 'UPDATE_HEALTH_ACTIVITY_INFO'
export const UPDATE_BANK_INFO = 'UPDATE_BANK_INFO'
export const UPDATE_DOC_SPE_LIST = 'update_doc_spe_list'
export const UPDATE_TECHNICAL_CONFIG = 'UPDATE_TECHNICAL_CONFIG'
export const UPDATE_GLOBAL_CONFIG = 'UPDATE_GLOBAL_CONFIG'
export const RUN_CONFORMITY = 'RUN_CONFORMITY'
export const RESET_CONFORMITY = 'RESET_CONFORMITY'

// TLC
export const CURRENT_MEETING_SET = 'current_meeting_set'
export const CURRENT_MEETING_CLOSED = 'current_meeting_closed'
export const MEETING_CANNOT_START = 'meeting_cannot_start'
export const UPDATE_LOCALE_STARTED_DATE = 'UPDATE_LOCALE_STARTED_DATE'
export const MEETINGS_NETWORK_TEST_SET = 'MEETINGS_NETWORK_TEST_SET'
export const MEETING_STARTED_CONSULTATION_SUCCESS = 'MEETING_STARTED_CONSULTATION_SUCCESS'
export const MEETING_STARTED_CONSULTATION_LEAVE = 'MEETING_STARTED_CONSULTATION_LEAVE'
export const MEETING_TOTAL = 'MEETING_TOTAL'
export const FORCE_CONSULTATIONS_PAGE_TAB = 'FORCE_CONSULTATIONS_PAGE_TAB'

export const CURRENT_ROOM_SUCCESS = 'current_room_success'
export const CURRENT_ROOM_CLOSED = 'current_room_closed'
export const RESET_QUALITY_INDICATOR = 'RESET_QUALITY_INDICATOR'
export const DISPLAY_CALL_SUSPENDED_ALERT = 'DISPLAY_CALL_SUSPENDED_ALERT'
export const CLOSE_CALL_SUSPENDED_ALERT = 'CLOSE_CALL_SUSPENDED_ALERT'
export const CALL_SUSPENDED = 'CALL_SUSPENDED'
export const ERROR_DURING_CALL_LEAVING = 'ERROR_DURING_CALL_LEAVING'
export const START_CALL_LEAVING = 'START_CALL_LEAVING'
export const FETCH_CLOSURE_BY_CARE_GIVER = 'FETCH_CLOSURE_BY_CARE_GIVER'
export const FETCH_PHOTO_SESSION = 'FETCH_PHOTO_SESSION'
export const PICTURES_FETCH_START = 'pictures_fetch_start'
export const PICTURES_FETCH_SUCCESS = 'pictures_fetch_success'
export const CLOSE_MESSAGE_SUCCESS = 'close_message_success'
export const STETHO_STREAM_STATUS_CHANGED = 'stetho_stream_status_changed'
export const DLU_URL_AVAILABLE = 'DLU_URL_AVAILABLE'
export const EXTERNAL_DOCUMENT_AVAILABLE = 'EXTERNAL_DOCUMENT_AVAILABLE'
export const EXTERNAL_DOCUMENT_AVAILABLE_LIST = 'EXTERNAL_DOCUMENT_AVAILABLE_LIST'
export const EXTERNAL_DOCUMENT_AVAILABLE_STARTED_CONSULTATION_LIST =
    'EXTERNAL_DOCUMENT_AVAILABLE_STARTED_CONSULTATION_LIST'
export const TERRESANTE_SET = 'TERRESANTE_SET'
export const PICTURE_DELETED = 'PICTURE_DELETED'
export const CLOSE_DELETED_MESSAGE = 'CLOSE_DELETED_MESSAGE'
export const DOCUMENT_DELETED = 'DOCUMENT_DELETED'
export const DOCUMENT_REFRESH = 'DOCUMENT_REFRESH'
export const DOCUMENT_FETCH_SUCCESS = 'DOCUMENT_FETCH_SUCCESS'
export const CLOSE_DOCUMENT_MESSAGE = 'CLOSE_DOCUMENT_MESSAGE'
export const CLOSE_DELETED_DOCUMENT_MESSAGE = 'CLOSE_DELETED_DOCUMENT_MESSAGE'

export const SHOW_ERROR_MESSAGE = 'show_error_message'
export const HIDE_ERROR_MESSAGE = 'hide_error_message'
export const SHOW_UNAVAILABILITY_ALERT = 'SHOW_UNAVAILABILITY_ALERT'
export const HIDE_UNAVAILABILITY_ALERT = 'HIDE_UNAVAILABILITY_ALERT'

export const SIGNATURE_CLEARED = 'signature_clear'
export const UPDATE_SIGNATURE = 'signature_update'

export const CONSULT_HISTORY_FETCH = 'consult_history_fetch'
export const CONSULT_HISTORY_FETCH_SUCCESS = 'consult_history_fetch_success'
export const CONSULT_HISTORY_3MONTH_UPDATE = 'consult_history_3month_update'
export const CONSULT_HISTORY_LOADED = 'consult_history_loaded'

export const MEDICAL_ACT_SELECT_MONTH = 'MEDICAL_ACT_SELECT_MONTH'
export const MEDICAL_ACT_OLDEST_FETCH = 'MEDICAL_ACT_OLDEST_FETCH'
export const HISTORY_REMINDER_FETCH = 'HISTORY_REMINDER_FETCH'
export const HISTORY_SYNTHESIS_LOADING = 'HISTORY_SYNTHESIS_LOADING'
export const HISTORY_SYNTHESIS_LOADED = 'HISTORY_SYNTHESIS_LOADED'
export const HISTORY_ALERT_DISPLAY = 'HISTORY_ALERT_DISPLAY'
export const HISTORY_ALERT_HIDE = 'HISTORY_ALERT_HIDE'

export const DISPLAY_FEEDBACK = 'display_feedback'
export const HIDE_FEEDBACK = 'hide_feedback'
export const HIDE_FEEDBACK_FOREVER = 'hide_feedback_forever'

// TLE
export const END_TRANSMISSION = 'end_transmission'
export const TRANSMISSION_TOTAL_PENDING = 'TRANSMISSION_TOTAL_PENDING'
export const TRANSMISSION_STARTED = 'TRANSMISSION_STARTED'
export const UPDATE_MAX_DISPLAYED_PENDING_TLE = 'UPDATE_MAX_DISPLAYED_PENDING_TLE'

export const BECOME_OFFLINE = 'BECOME_OFFLINE'
export const BECOME_ONLINE = 'BECOME_ONLINE'

export const INSERT_REPORT_ITEM = 'INSERT_REPORT_ITEM'
export const INTRO_NEXT_STEP = 'INTRO_NEXT_STEP'
export const WEBCAM_NEXT_STEP = 'WEBCAM_NEXT_STEP'
export const WEBCAM_RESET = 'WEBCAM_RESET'
export const MICRO_RESET = 'MICRO_RESET'
export const SPEAKER_RESET = 'SPEAKER_RESET'
export const MICROPHONE_NEXT_STEP = 'MICROPHONE_NEXT_STEP'
export const SPEAKER_NEXT_STEP = 'SPEAKER_NEXT_STEP'
export const WEBRTC_NEXT_STEP = 'WEBRTC_NEXT_STEP'
export const GO_TO_WEBCAM = 'GO_TO_WEBCAM'
export const GO_TO_MICROPHONE = 'GO_TO_MICROPHONE'
export const GO_TO_SPEAKER = 'GO_TO_SPEAKER'
export const GO_TO_WEBRTC = 'GO_TO_WEBRTC'
export const GO_TO_REPORT = 'GO_TO_REPORT'
export const GO_TO_EXAMPLE2 = 'GO_TO_EXAMPLE2'
export const WEBRTC_P2P_OK = 'WEBRTC_P2P_OK'

export const TRANSMISSION_BEGIN_REGEN = 'TRANSMISSION_BEGIN_REGEN'
export const TRANSMISSION_LEAVE = 'TRANSMISSION_LEAVE'

export const FEEDBACK_DIALOG_UPDATE_TITLE = 'FEEDBACK_DIALOG_UPDATE_TITLE'
export const FEEDBACK_DIALOG_UPDATE_DISPLAY_DIALOG = 'FEEDBACK_DIALOG_UPDATE_DISPLAY_DIALOG'
export const FEEDBACK_DIALOG_UPDATE_CONTENT = 'FEEDBACK_DIALOG_UPDATE_CONTENT'
export const FEEDBACK_DIALOG_UPDATE_ERROR = 'FEEDBACK_DIALOG_UPDATE_ERROR'
export const FEEDBACK_DIALOG_RESET = 'FEEDBACK_DIALOG_RESET'

export const THEME_SWITCH = 'THEME_SWITCH'

export const DEMO_MODE_INITIATOR_ACTIVE = 'DEMO_MODE_INITIATOR_ACTIVE'
export const DEMO_MODE_TLC_ACTIVE = 'DEMO_MODE_TLC_ACTIVE'

export const PICTURE_REORDERED = 'PICTURE_REORDERED'

export const ACT_MODULE_NAVIGATION_TOGGLE = 'ACT_MODULE_NAVIGATION_TOGGLE'
export const ACT_MODULE_FINISH_TOGGLE = 'ACT_MODULE_FINISH_TOGGLE'
